import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { SharedModule } from '../../../shared.module';
import { WidgetNumberDisplayComponent } from '../widget-number-display/widget-number-display.component';

@Component({
  selector: 'app-widget-orders-display',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetNumberDisplayComponent, SharedModule],
  template: `
    <app-widget-number-display
      [number]="orderCount"
      [label]="'Active Orders'"
      [icon]="'check'"
      [hyperlink]="hyperlink"
      [ctaText]="'View All'"
      [navigateOnClick]="navigateOnClick"
      [loading]="loading"
    >
      <div>{{ locationCount }} {{ locationCount | pluralize: 'location' }}</div>
    </app-widget-number-display>
  `,
})
export class WidgetOrdersDisplayComponent {
  @Input() loading: boolean = true;

  @Input() hyperlink: string | null = null;

  @Input() navigateOnClick: boolean = false;

  @Input() locationCount: number = 0;

  @Input() orderCount: number = 0;
}
